import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { onlineTourPreferredCategories } from '../api';
import { SearchForm } from '../components/SearchForm';
import { IOnlinePreferredTourCategory } from '../utils/types';
import { TourCategoryButtons } from '../components/TourCategoryButtons';

export default function SearchTour() {
  const [toursCategories, setToursCategories] = useState<
    IOnlinePreferredTourCategory[]
  >([]);

  useEffect(() => {
    fetchTourCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchTourCategories = async () => {
    try {
      const res = await onlineTourPreferredCategories(false);
      const toursCategories = await res.json();
      setToursCategories(toursCategories);
    } catch (e: any) {
      console.log(e);
    }
  };

  return (
    <Box
      sx={{
        mx: 'auto',
        maxWidth: 1046,
      }}
    >
      <TourCategoryButtons data={toursCategories} />
      <Box
        sx={{
          px: 2,
          py: 1,
          mt: 2,
          bgcolor: (t) => t.palette.secondary.main,
          borderRadius: 1,
        }}
      >
        <SearchForm />
      </Box>
    </Box>
  );
}
